import FileInfo from './FileInfo';

export default FileInfo;
